module.exports = __webpack_public_path__ + "cb4f5fb46358b36b864ef85d02ae9a7c.pdf";